import axios from 'axios'

import { handleCloudflareChallenge,isCloudflareChallenge } from './axios-interceptors/cloudflare'

axios.interceptors.response.use(
  async (response) => {
    if (isCloudflareChallenge(response)) {
      const config = await handleCloudflareChallenge(response.config)
      return axios(config)
    }
    return response
  },

  async (error) => {
    error.message = error.response?.data?.message || error.message
    
    if (isCloudflareChallenge(error?.response)) {
      const config = await handleCloudflareChallenge(error.config)
      return axios(config)
    }

    return Promise.reject(error)
  },
)

// Precedence: VITE_API_URL (incl. empty string = same-origin / Vite
// proxy mode) → window.config.api_url from bootstrap → empty.
const apiBaseURL = import.meta.env?.VITE_API_URL !== undefined
  ? import.meta.env.VITE_API_URL
  : ((typeof window !== 'undefined' && window.config?.api_url) || '')

const axiosInstance = axios.create({
  baseURL: apiBaseURL,
  withCredentials: Boolean(apiBaseURL),
  mode: 'cors',
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.headers) {
      config.headers = {}
    }
    config.headers['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone
    return config
  },
  (error) => Promise.reject(error),
)

export default axiosInstance
